<template>
  <HeaderFullpage :title="t('showcase.services.createNew')" />
  <PageLoader v-if="isLoading" />
  <LayoutBase
    v-else
    gap="40"
  >
    <ServicesForm
      ref="servicesForm"
      :handler="create"
    />

    <SuccessModal
      ref="successModal"
      @retry="servicesForm.reset()"
      @close="router.back()"
    />
  </LayoutBase>
</template>

<script setup>
import { ref, } from 'vue'
import { HeaderFullpage, } from '@/UI'
import { LayoutBase } from '@/components/Layouts'
import { PageLoader } from '@/components/PageLoader'
import { useRouter, useRoute } from 'vue-router'
import ServicesForm from '../../workspace/ServicesForm.vue'
import { uploadPhoto } from '@/states/api'
import showcasesApi from '@/screens/Account/api/showcases.api'
import SuccessModal from '../../workspace/SuccessModal.vue'
import { errorToast, } from '@/helpers/showToast'

import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const route = useRoute()
const router = useRouter()
const isLoading = ref(false)
const successModal = ref()
const servicesForm = ref()

async function create(payload) {
  if (payload.files.length) {
    const { paths } = await uploadPhoto({ photos: payload.files })
    payload.files = paths.map((el) => el.path)
  }

  showcasesApi
    .create(route.params.id, payload)
    .then((res) => {
      if (res.data.success) {
        successModal.value.openModal(t('showcase.services.createSuccess'))
      } else {
        errorToast({
          description: t('toast.somethingWrongLong'),
        })
      }
    })
    .catch(() => {
      errorToast({
        description: t('toast.somethingWrongLong'),
      })
    })
}
</script>

<style lang="scss" src="../../assets/styles.scss"></style>
